import React, { useCallback } from "react"
import _ from "lodash"
import { useTheme, Avatar, ListItemButton, Box, Stack } from "@mui/material"
import clsx from "clsx"
import { YouAreHereChipIcon } from "../icons"

export const VenueSelector = (props) => {
  const {
    venues = [],
    onClickVenue = () => {},
    selectedVenue,
    currentVenue,
  } = props
  const theme = useTheme()
  const styleOverrides = theme.components[`VenueSelector`]?.styleOverrides || {}
  const { root, buttonWrapper, button, icon, currentVenueChip } = styleOverrides
  const handleClick = useCallback(
    (venueId) => () => {
      onClickVenue(venueId)
    },
    [onClickVenue]
  )
  if (venues.length === 0) return null
  return (
    <Stack direction="row" sx={root}>
      {venues.map((venue) => {
        const { id } = venue
        const isSelectedVenue = selectedVenue === id
        const logo = _.get(venue, "properties.logo_simple.url", "")
        const ref = _.get(venue, "properties.reference", "")
        const isCurrentVenue = currentVenue === venue.id
        return (
          <Box
            key={id}
            className={clsx(ref, isSelectedVenue ? "selected" : "")}
            sx={buttonWrapper}
          >
            <ListItemButton
              selected={isSelectedVenue}
              sx={button}
              onClick={handleClick(id)}
            >
              <Avatar alt="venue-logo" src={logo} sx={icon} />
            </ListItemButton>
            {isCurrentVenue && <YouAreHereChipIcon sx={currentVenueChip} />}
          </Box>
        )
      })}
    </Stack>
  )
}
